import AvoFont from '../static/Assets/Fonts/utm_avo.woff';
import AvoFontBold from '../static/Assets/Fonts/utm_avobold.woff';
import AvoFontBoldItalic from '../static/Assets/Fonts/utm_avobold_italic.woff';
import AvoFontItalic from '../static/Assets/Fonts/utm_avoitalic.woff';
import GothamExtraLight from '../static/Assets/Fonts/gotham_extralight.woff';

export const FontConfig = {
  file: [
    {
    fontFamily: 'UTMAvoRegular',
    fontStyle: 'normal',
    fontWeight: 'normal',
    file: AvoFont,
    fontType: 'woff',
    fileLocal: 'ATMAvoRegular'
    },
    {
      fontFamily: 'UTMAvoBold',
      fontStyle: 'normal',
      fontWeight: 'normal',
      file: AvoFontBold,
      fontType: 'woff',
      fileLocal: 'UTMAvoBold'
    },  
    {
      fontFamily: 'UTMAvoBoldItalic',
      fontStyle: 'normal',
      fontWeight: 'normal',
      file: AvoFontBoldItalic,
      fontType: 'woff',
      fileLocal: 'UTMAvoBoldItalic'
    },
    {
      fontFamily: 'UTMAvoItalic',
      fontStyle: 'normal',
      fontWeight: 'normal',
      file: AvoFontItalic,
      fontType: 'woff',
      fileLocal: 'UTMAvoItalic'
    },
    {
      fontFamily: 'GothamExtraLight',
      fontStyle: 'normal',
      fontWeight: 'normal',
      file: GothamExtraLight,
      fontType: 'woff',
      fileLocal: 'GothamExtraLight'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/config/font.js